/**
 * 模組頁面代碼: 1320-UI
 * 模組說明: 角色權限管理功能頁面框架
 * @module RolePermissionContainer
 */

// ----- import from local libraries -----
import {
  React,
  PropTypes,
  connect,
  BaseComponent,
} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import RolePermissionPage from './components/RolePermissionPage';
import RolePermissionModal from './components/RolePermissionModal';
import RoleListModal from './components/RoleListModal';
import RoleModal from './components/RoleModal';
import {AlertModal, AlertModalModeEnums} from '../../components/AlertModal';
import {
  MessageModal,
  MessageModalModeEnums,
} from '../../components/MessageModal';
import enumList from 'web/utils/enumList';

// ----- import from local actions -----
import {
  addRole,
  editRole,
  editRoleStatus,
  fetchRole,
  fetchRoleList,
  fetchRoleSelection,
} from '../../redux/actions/RoleActions';
import {fetchModuleSelection} from '../../redux/actions/ModuleActions';
import {
  addRolePermission,
  editRolePermission,
  deleteRolePermission,
  fetchRolePermissionList,
} from '../../redux/actions/RolePermissionActions';
import {showMessage} from 'web/utils/modalHelper';

// ----- constants and enums -----
const RoleModalModeEnums = {
  NEW: 'new',
  EDIT: 'edit',
};

const RolePermissionModalModeEnums = {
  NEW: 'new',
  EDIT: 'edit',
};

const ACTION_TARGET_ROLE = 'role';
const ACTION_TARGET_ROLE_PERMISSION = 'rolePermission';

/**
 *
 */
class RolePermissionContainer extends BaseComponent {
  /**
   *
   */
  constructor(props) {
    super(props);
    // 創建 ref
    this.rolePermissionModalRef = React.createRef();
    this.roleListModalRef = React.createRef();
    this.roleModalRef = React.createRef();
    this.alertModalRef = React.createRef();
    this.messageModalRef = React.createRef();
    this.dtableRef = React.createRef();
    this.rolePermissionModal = null;
    this.roleListModal = null;
    this.roleModal = null;
    this.alertModal = null;
    this.messageModal = null;

    this.state = {
      needRolePermissionLoad: false,
      needRoleListLoad: false,
      roleModalMode: RoleModalModeEnums.NEW,
      rolePermissionModalMode: RolePermissionModalModeEnums.NEW,
      actionMode: AlertModalModeEnums.DELETE,
      actionTarget: '',
      rolePermission: null,
      role: null,
      alertMessage: '',
      actionIds: [],
      message: {mode: enumList.messageModalMode.error, title: '', body: ''},
      search: {roleId: 0, moduleId: 0},
    };
    this.toggleRolePermissionModal = this.toggleRolePermissionModal.bind(this);
    this.toggleRoleListModal = this.toggleRoleListModal.bind(this);
    this.toggleRoleModal = this.toggleRoleModal.bind(this);
    this.toggleAlertModal = this.toggleAlertModal.bind(this);
    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  /**
   *
   */
  toggleRolePermissionModal(
    isShow,
    mode = RolePermissionModalModeEnums.NEW,
    index = null,
  ) {
    if (this.rolePermissionModal) {
      if (mode === RolePermissionModalModeEnums.EDIT) {
        this.setState({rolePermission: this.props.rolePermissionList[index]});
      } else {
        this.setState({rolePermission: null});
      }

      if (isShow) {
        this.rolePermissionModal.show();
      } else {
        this.rolePermissionModal.hide();
      }
      this.setState({rolePermissionModalMode: mode});
    }
  }

  /**
   *
   */
  toggleRoleListModal(isShow) {
    if (this.roleListModal) {
      if (isShow) {
        this.roleListModal.show();
      } else {
        this.roleListModal.hide();
      }
    }
  }

  /**
   *
   */
  toggleRoleModal(isShow, mode = RoleModalModeEnums.NEW, index = null) {
    if (this.roleModal) {
      if (mode === RoleModalModeEnums.EDIT) {
        this.setState({role: this.props.roleList[index]});
      } else {
        this.setState({role: null});
      }

      if (isShow) {
        this.roleModal.show();
      } else {
        this.roleModal.hide();
      }
      this.setState({roleModalMode: mode});
    }
  }

  /**
   *
   */
  toggleAlertModal(
    isShow,
    mode = AlertModalModeEnums.ENABLE,
    target,
    message = '',
    actionIds = [],
  ) {
    if (this.alertModal) {
      if (isShow) {
        let alertMessage = message;
        if (alertMessage === '') {
          const length = actionIds.length;
          if (mode === AlertModalModeEnums.ENABLE) {
            alertMessage = `啟用 [ ${length} ] 筆資料`;
          } else if (mode === AlertModalModeEnums.DISABLE) {
            alertMessage = `停用 [ ${length} ] 筆資料`;
          } else if (mode === AlertModalModeEnums.DELETE) {
            alertMessage = `刪除 [ ${length} ] 筆資料`;
          }
        }
        this.setState({actionMode: mode});
        this.setState({alertMessage: alertMessage});
        this.setState({actionTarget: target});
        this.setState({actionIds: actionIds});
        this.alertModal.show();
      } else {
        this.alertModal.hide();
      }
    }
  }

  /**
   *
   */
  toggleMessageModal(
    isShow,
    mode = enumList.messageModalMode.info,
    title = '',
    message = '',
  ) {
    if (this.messageModal) {
      if (isShow) {
        let body = message;
        const statusCode = message?.code || '';
        if (statusCode !== '') {
          body = `[ ${statusCode} ] ${message.message}`;
        }
        this.setState({message: {mode: mode, title: title, body: body}});
        this.messageModal.show();
      } else {
        this.messageModal.hide();
      }
    }
  }

  /**
   *
   */
  onConfirm() {
    const actionTarget = this.state.actionTarget;
    const actionMode = this.state.actionMode;
    const actionIds = this.state.actionIds;

    if (actionTarget === ACTION_TARGET_ROLE) {
      const roleId = actionIds[0];
      const status = actionMode === AlertModalModeEnums.ENABLE ? 'A' : 'I';
      this.props.editRoleStatus(roleId, status).then(() => {
        // this.props.fetchRoleSelection();
        setTimeout(() => {
          this.props.fetchRoleList().then((res) => {
            this.setState({needRoleListLoad: true});
            this.toggleAlertModal(false);
            this.toggleRoleListModal(true);
          });
        }, 100);
      });
    } else if (actionTarget === ACTION_TARGET_ROLE_PERMISSION) {
      const permissionIdsString = actionIds.join(',');
      if (actionMode === AlertModalModeEnums.DELETE) {
        this.props.deleteRolePermission(permissionIdsString).then(() => {
          const {roleId, moduleId} = this.state.search;
          this.props.fetchRolePermissionList(roleId, moduleId).then(() => {
            this.setState({needRolePermissionLoad: true});
            this.toggleAlertModal(false);
          });
        });
      }
    }
  }

  /**
   *
   */
  componentDidMount() {
    // 頁面所需資料初始化
    // this.props.fetchRoleSelection(); 角色類別合併至 fetchRolePermissionList 取得
    this.dtableRef.current.processing(true);
    this.props.fetchModuleSelection();
    this.props.fetchRolePermissionList(0, 0).then(() => {
      this.setState({needRolePermissionLoad: true});
    });
    this.props.fetchRoleList().then(() => {
      this.setState({needRoleListLoad: true});
    });
    this.rolePermissionModal = new bootstrap.Modal(
      this.rolePermissionModalRef.current,
    );
    this.roleListModal = new bootstrap.Modal(this.roleListModalRef.current);
    this.roleModal = new bootstrap.Modal(this.roleModalRef.current);
    this.alertModal = new bootstrap.Modal(this.alertModalRef.current);
    this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
  }

  /**
   *
   */
  componentDidUpdate(prevProps, prevState) {}

  /**
   *
   */
  componentWillUnmount() {
    this.toggleRolePermissionModal(false);
    this.toggleRoleListModal(false);
    this.toggleRoleModal(false);
    this.toggleAlertModal(false);
    this.toggleMessageModal(false);
  }

  /**
   *
   */
  render() {
    return (
      <React.Fragment>
        <div className="m__wrap">
          <Header />
          <div className="m__contents">
            <Sidebar />
            <RolePermissionPage
              {...this.props}
              dtableRef={this.dtableRef}
              needRolePermissionLoad={this.state.needRolePermissionLoad}
              setNeedRolePermissionLoad={(bLoad) =>
                this.setState({needRolePermissionLoad: bLoad})
              }
              onNewRolePermission={() =>
                this.toggleRolePermissionModal(
                  true,
                  RolePermissionModalModeEnums.NEW,
                )
              }
              onEditRolePermission={(index) =>
                this.toggleRolePermissionModal(
                  true,
                  RolePermissionModalModeEnums.EDIT,
                  index,
                )
              }
              onDeleteRolePermission={(message, permissionId) =>
                this.toggleAlertModal(
                  true,
                  AlertModalModeEnums.DELETE,
                  ACTION_TARGET_ROLE_PERMISSION,
                  message,
                  [permissionId],
                )
              }
              onBatchHandle={(mode, permissionIds) =>
                this.toggleAlertModal(
                  true,
                  mode,
                  ACTION_TARGET_ROLE_PERMISSION,
                  '',
                  permissionIds,
                )
              }
              setSearchRolePermission={(roleId, moduleId) => {
                this.setState({search: {roleId: roleId, moduleId: moduleId}});
              }}
              onRoleList={() => this.toggleRoleListModal(true)}
            />
          </div>
          <Footer />
        </div>
        <RoleListModal
          {...this.props}
          ref={this.roleListModalRef}
          checkPermission={this.checkPermission.bind(this)}
          needRoleListLoad={this.state.needRoleListLoad}
          setNeedRoleListLoad={(bLoad) =>
            this.setState({needRoleListLoad: bLoad})
          }
          onNewRole={() => {
            this.toggleRoleModal(true, RoleModalModeEnums.NEW);
            this.toggleRoleListModal(false);
          }}
          onEditRole={(index) => {
            this.toggleRoleModal(true, RoleModalModeEnums.EDIT, index);
            this.toggleRoleListModal(false);
          }}
          onEditRoleStatus={(mode, message, roleId) => {
            this.toggleAlertModal(true, mode, ACTION_TARGET_ROLE, message, [
              roleId,
            ]);
            this.toggleRoleListModal(false);
          }}
        />
        <RolePermissionModal
          {...this.props}
          ref={this.rolePermissionModalRef}
          mode={this.state.rolePermissionModalMode}
          rolePermission={this.state.rolePermission}
          searchRolePermission={this.state.search}
          setNeedRolePermissionLoad={(bLoad) =>
            this.setState({needRolePermissionLoad: bLoad})
          }
          onErrorHandle={(title, message) => {
            showMessage(
              enumList.messageModalMode.error,
              title,
              message.message,
            );
          }}
        />
        <RoleModal
          {...this.props}
          ref={this.roleModalRef}
          mode={this.state.roleModalMode}
          role={this.state.role}
          setNeedRoleListLoad={(bLoad) => {
            this.setState({needRoleListLoad: bLoad});
            this.toggleRoleListModal(true);
          }}
          onErrorHandle={(title, message) =>
            showMessage(enumList.messageModalMode.error, title, message.message)
          }
          rolePermission={this.state.rolePermission}
          searchRolePermission={this.state.search}
          setNeedRolePermissionLoad={(bLoad) =>
            this.setState({needRolePermissionLoad: bLoad})
          }
        />
        <AlertModal
          ref={this.alertModalRef}
          mode={this.state.actionMode}
          message={this.state.alertMessage}
          onConfirm={() => this.onConfirm()}
          onCancel={() => this.setState({needRolePermissionLoad: true})}
        />
        <MessageModal
          ref={this.messageModalRef}
          mode={this.state.message.mode}
          title={this.state.message.title}
          message={this.state.message.body}
        />
      </React.Fragment>
    );
  }
}

RolePermissionContainer.propTypes = {
  userPermissions: PropTypes.array,
  roleSelection: PropTypes.array,
  roleList: PropTypes.array,
  moduleSelection: PropTypes.array,
  rolePermissionList: PropTypes.array,
};

RolePermissionContainer.defaultProps = {
  userPermissions: [],
  roleSelection: [],
  roleList: [],
  moduleSelection: [],
  rolePermissionList: [],
};

/**
 *
 */
function mapStateToProps(state) {
  return {
    userPermissions: JSON.parse(state.access.userPermissions),
    roleSelection: state.role.roleSelection.data,
    roleList: state.role.roleList.data,
    moduleSelection: state.module.moduleSelection.data,
    rolePermissionList: state.rolePermission.rolePermissionList.data,
  };
}

/**
 *
 */
function mapDispatchToProps(dispatch) {
  return {
    addRole: (role) => {
      return dispatch(addRole(role));
    },
    editRole: (role) => {
      return dispatch(editRole(role));
    },
    editRoleStatus: (roleId, status) => {
      return dispatch(editRoleStatus({roleId, status}));
    },
    fetchRole: (roleId) => {
      return dispatch(fetchRole(roleId));
    },
    fetchRoleSelection: () => {
      return dispatch(fetchRoleSelection());
    },
    fetchRoleList: () => {
      return dispatch(fetchRoleList());
    },
    fetchModuleSelection: () => {
      return dispatch(fetchModuleSelection());
    },
    fetchRolePermissionList: (roleId, moduleId) => {
      return dispatch(fetchRolePermissionList({roleId, moduleId}));
    },
    addRolePermission: (rolePermission) => {
      return dispatch(addRolePermission(rolePermission));
    },
    editRolePermission: (rolePermission) => {
      return dispatch(editRolePermission(rolePermission));
    },
    deleteRolePermission: (rolePermissionIds) => {
      return dispatch(deleteRolePermission(rolePermissionIds));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RolePermissionContainer);
